<template>
    <div style="width:100%;height: 100%;">
        <el-upload class="myupload" v-if="!value" :accept="accept" :disabled="disabled" :class="{ isdisabled: disabled }" :action="ossurl" :multiple="true" :http-request="httpRequest" :data="ossdate" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeupload" :show-file-list="false" drag>
            <div style="width:100%;height: 100%;display: flex; flex-direction: column; justify-content: center;">
                <i class="el-icon-upload" style="margin: 0;"></i>
                <div class="el-upload__text" v-if="keyname">{{ keyname }}</div>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
        </el-upload>
        <div v-else class="el-upload-dragger" @click="showbig = true;">
            <img :src="value" style="max-width: 100%;height: 100%;">
        </div>
        <el-dialog :visible.sync="showbig" >
            <div style="display: flex;justify-content: center;">
                <img :src="value" style="width: 300px;">
            </div>
            
            <div slot="footer" class="dialog-footer">
                <el-button type="danger" v-if="!disabled" @click="ondel">删 除</el-button>
                <el-button @click="showbig = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ajax from './ajax';
import axios from 'axios'

//多文件上传的时候,因为共用了一个ossdate,而osskey就在这个   http-request
/*
上传文件到oss组件(web直传)
1.  利用getOssSign函数获取oss签名数据
2.  el-upload组件直接把图片提交到oss服务器

集成了图片自动压缩和webp格式转换

*/
export default {
    props: {
        value: {
            type: String,
            default: '',
        },
        getOssSign: {
            type: Function,
            default: async () => {
                return {};
            },
        },
        path: {
            type: String,
        },
        keyname: {
            type: String,
            default: '',
        },
        keytime: {
            type: Boolean,
            default: true,
        },
        disabled: {
            default: false,
        },
        accept: {
            type: String,
            default: 'image/*',
        },
        imgsize: {
            type: Number,
            default: 900,
        },
        // ossurl: {
        //     type: String,
        //     default: '',  
        // }
    },
    data() {
        return {
            ossdate: {},
            showbig: false,
            ossurl: '',
            ossdateList: [],
            uploaded定时器: null,
        }
    },
    async mounted() {
        try {
            if (!this.ossdate.ossurl) this.ossdate = await this.getOssSign() || {};
            if (!this.ossdate.ossurl) throw 'getOss返回数据错误,ossurl为空!';
            this.ossdateList = [];
        } catch (error) {
            this.$Alert(error);
        }
    },
    methods: {
        async beforeupload(file) {
            let name = '';
            try {
                if (!this.path) throw '上传文件路径path为空!';
                if (this.path.startsWith('/')) throw '上传文件路径path不能以/开头!';
                if (!this.ossdate.ossurl) this.ossdate = await this.getOssSign() || {};
                if (!this.ossdate.ossurl) throw 'getOss返回数据错误,ossurl为空!';

                let 扩展名 = (file.name.split('.')[1] || 'jpg');
                let 文件名 = file.name.split('.')[0];
                //去除文件名中的空格 和其他不合法字符
                文件名 = 文件名.replace(/\s+/g, "").replace(/[|?"<>/*\\\\]+/g, "");

                if (this.keyname) {
                    name = this.keyname + '-' + (this.keytime ? this.keytime : new Date().getTime());
                } else {
                    name = 文件名 + '-' + new Date().getTime();
                }
                if (!name) throw '上传文件名称不能为空!';

                //todo  判断后缀,只有图片格式 才需要压缩处理
                let base64image = '';
                if (file.size == 0) throw '图片尺寸为0，应该是图片文件损坏了！';

                if (file.size / 1024 / 1024 > 2) {
                    let image = await this.fileToImage(file);
                    base64image = await this.compressUpload(image, file.type, 1000);
                    //console.log('图片尺寸大于2M，利用canvas压缩', base64image);
                } else {
                    base64image = await this.fileToBase64(file);
                    //console.log('图片尺寸小于2M，直接读取base64', base64image);
                }
                //图片转成webp格式
                let tmpwebp = await this.toWebp(base64image, 0, 500);
                let resultBlob = this.dataURItoBlob(tmpwebp);
                //console.log('图片转换到webp', resultBlob);

                this.ossdate.key = this.path + name + '.webp';
                this.ossurl = this.ossdate.ossurl;
                file.data = JSON.parse(JSON.stringify(this.ossdate));

                //console.log(resultBlob);
                return resultBlob;
            } catch (error) {
                this.$Alert(error);
                throw error;
            }
        },
        fileToBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    resolve(reader.result);
                }
                reader.onerror = (error) => {
                    reject(error);
                }
            })
        },
        fileToImage(file) {
            return new Promise((resolve, reject) => {
                let image = new Image();
                image.src = URL.createObjectURL(file);
                image.onload = () => {
                    resolve(image);
                }
                image.onerror = (error) => {
                    reject(error);
                }
            })
        },
        //测试一下compressorjs
        async compressUpload(image, type, s = 900) {
            //console.log(image);
            //获取图片base64
            //let base64 = image.src;
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            let initSize = image.src.length
            let { width } = image, { height } = image;
            let w = width, h = height;

            if (width > height) {
                if (width < s) s = width;
                w = s;
                h = (w / width) * height;
            } else {
                if (height < s) s = height;
                h = s;
                w = (h / height) * width;
            }
            canvas.width = w;
            canvas.height = h;
            ctx.fillRect(0, 0, canvas.width, canvas.height)
            ctx.drawImage(image, 0, 0, width, height, 0, 0, canvas.width, canvas.height)

            // 进行最小压缩0.1
            let compressData = canvas.toDataURL(type || 'image/jpeg', 1);
            return compressData
        },
        /* base64转Blob对象 */
        dataURItoBlob(data) {
            let byteString;
            if (data.split(',')[0].indexOf('base64') >= 0) {
                byteString = atob(data.split(',')[1])
            } else {
                byteString = unescape(data.split(',')[1])
            }
            let mimeString = data
                .split(',')[0]
                .split(':')[1]
                .split(';')[0];
            let ia = new Uint8Array(byteString.length)
            for (let i = 0; i < byteString.length; i += 1) {
                ia[i] = byteString.charCodeAt(i)
            }
            return new Blob([ia], { type: mimeString })
        },
        async toWebp(base64, width, height = 0) {
            let result = await this.$postAsync('/api/oss', {
                cmd: '转换图片webp',
                base64, width, height
            });
            return result.data;
        },
        async 压缩图片(filePath, width, height = 0) {

            let res = await axios({
                method: "POST",
                url: this.host + '/api/oss',
                // data: postdata,
                // timeout: timeouttime,
                headers: {
                    'token': window.token,
                    'Content-Type': 'multipart/form-data'
                },
            });
        },

        uploadError(err, file, fileList) {
            this.$Alert('图片上传失败！' + (err.message || JSON.stringify(err)));
        },
        uploadSuccess(err, file, fileList) {
            this.$emit('input', this.ossurl + this.ossdate.key);
            if (this.uploaded定时器) clearTimeout(this.uploaded定时器);
            this.uploaded定时器 = setTimeout(() => {
                this.$emit('uploaded', this.ossurl + this.ossdate.key, this.keyname);
            }, 500);
        },
        ondel() {
            this.showbig = false;
            // this.$emit('input', '');
            this.$emit('ondelete', this.value);
        },
        httpRequest(option) {
            ajax(option)
        },
    }
}
</script>

<style lang="scss">
.isdisabled,
.isdisabled .el-upload,
.isdisabled .el-upload-dragger {
    cursor: not-allowed;
}
.el-upload-dragger {
    width: 100%;
    // height: 100%;
    height: 140px !important;
}
.myupload {
    width: 100%;
    height: 100%;
    line-height: 20px;

    .el-upload {
        width: 100%;
        height: 100%;

        .el-upload-dragger {
            width: 100%;
            height: 100%;
        }
    }
}

</style>